import { render, staticRenderFns } from "./CustomFitPopup.vue?vue&type=template&id=4981e7f0&scoped=true&"
import script from "./CustomFitPopup.vue?vue&type=script&lang=js&"
export * from "./CustomFitPopup.vue?vue&type=script&lang=js&"
import style0 from "./CustomFitPopup.vue?vue&type=style&index=0&id=4981e7f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4981e7f0",
  null
  
)

export default component.exports